import React, { Component } from 'react'
import app from '../../feathers'
import { Route, Link, withRouter } from 'react-router-dom'
import Button from '../../components/Button'
import styled from 'styled-components'
import moment from 'moment'
import { Switch as Toggle, Menu, MenuItem, Icon } from 'react-mdl'
import DuplicateDialog from './DuplicateDialog'

const TableContainer = styled.div`
  max-height: 660px;
  overflow-y: auto;
`
const Table = styled.table`
  width: 100%;
  border: 1px solid black;
  border-spacing: 0;
  thead tr {
    background-color: #cccccc;
    height: 25px;
    line-height: 25px;
  }
  tbody tr:nth-child(odd) {
    background-color: #eeeeee;
  }
  tbody td {
    padding: 0.25em;
  }
  tr td,
  tr th {
    border-right: 1px solid black;
    width: 100px;
    text-align: left;
  }
  tr td:first-child,
  tr th:first-child {
    width: 10%;
  }
  tr td:nth-child(3),
  tr th:nth-child(3) {
    width: 15%;
    text-align: center;
  }
  tr td:last-child,
  tr th:last-child {
    width: 20%;
    text-align: center;
  }
`
const ThContent = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 1px;
`
const ActionsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
`
const StyledToggle = styled(Toggle)`margin: 5px;`
const PaginationContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
  p {
    margin: 5px;
  }
`
const PaginationButton = styled.button`
  width: ${({ width }) => width};
  height: 20px;
  text-align: center;
  vertical-align: middle;
  padding: 0px;
  margin: 5px;
`

const SortableTh = ({
  label,
  sortField,
  handleUpdateSort,
  currentSortField,
  sortDirection,
}) => (
  <th onClick={handleUpdateSort({ sortField })}>
    <ThContent>
      {label}
      {currentSortField === sortField ? (
        <Icon
          name={
            sortDirection === -1 ? 'keyboard_arrow_down' : 'keyboard_arrow_up'
          }
        />
      ) : (
        <div />
      )}
    </ThContent>
  </th>
)

const unitsService = app.service('units')

class UnitsScreen extends Component {
  state = {
    units: [],
    unitsLoading: false,
    total: 0,
    page: 0,
    pageSize: 10,
    showArchived: false,
    sortField: 'updatedAt',
    sortDirection: -1,
  }
  componentDidMount() {
    // listen to changes on the units service
    unitsService.on('created', this.fetchUnits)
    unitsService.on('updated', this.fetchUnits)
    unitsService.on('patched', this.fetchUnits)
    unitsService.on('removed', this.fetchUnits)

    this.fetchUnits()
  }
  componentWillUnmount() {
    // stop listening to changes on the units service
    unitsService.off('created', this.fetchUnits)
    unitsService.off('updated', this.fetchUnits)
    unitsService.off('patched', this.fetchUnits)
    unitsService.off('removed', this.fetchUnits)
  }
  get totalPages() {
    const { total, pageSize } = this.state
    return Math.ceil(total / pageSize) || 1
  }
  fetchUnits = async () => {
    const {
      page,
      pageSize,
      showArchived,
      sortField,
      sortDirection,
    } = this.state
    const { data, total } = await unitsService.find({
      query: {
        $select: ['code', 'title', 'updatedAt', 'hidden'],
        $skip: page * pageSize,
        $limit: pageSize,
        hidden: showArchived,
        $sort: {
          [`${sortField}`]: sortDirection,
        },
        $disableSoftDelete: showArchived ? true : undefined,
      },
    })
    // if we are out of current bounds and there is then move back in and refetch
    if (data.length === 0 && total > 0 && page > 0) {
      const lastPage = Math.ceil(total / pageSize) - 1
      this.setState({ page: lastPage }, this.fetchUnits)
      return
    }
    this.setState({ units: data, total })
  }
  handleArchiveUnit = async unitId => {
    await unitsService.remove(unitId)
  }
  handleRestoreUnit = async unitId => {
    await unitsService.patch(
      unitId,
      { hidden: false },
      { query: { $disableSoftDelete: true } },
    )
  }
  handleChangePageSize = async e => {
    this.setState({ pageSize: e.target.value }, this.fetchUnits)
  }
  handleNextPage = () => {
    const { page } = this.state
    if (page + 1 <= this.totalPages) {
      this.setState({ page: page + 1 }, this.fetchUnits)
    }
  }
  handlePreviousPage = () => {
    const { page } = this.state

    if (page > 0) {
      this.setState({ page: page - 1 }, this.fetchUnits)
    }
  }
  toggleShowArchived = () => {
    this.setState(
      ({ showArchived: s }) => ({ page: 0, showArchived: !s }),
      this.fetchUnits,
    )
  }
  handleUpdateSort = ({ sortField }) => () => {
    const { sortField: currentSortField, sortDirection } = this.state
    // if changing columns, set sort to ascending, otherwise inverse current direction
    const direction =
      sortField !== currentSortField ? 1 : sortDirection === 1 ? -1 : 1
    this.setState({ sortField, sortDirection: direction }, this.fetchUnits)
  }

  render() {
    const {
      units,
      unitsLoading,
      showArchived,
      page,
      pageSize,
      sortField,
      sortDirection,
    } = this.state
    const totalPages = this.totalPages

    return (
      <div>
        <Route
          strict
          exact
          path="/units/duplicate/:unitId"
          component={DuplicateDialog}
        />
        <h3>Units</h3>
        <StyledToggle checked={showArchived} onChange={this.toggleShowArchived}>
          <p>Show Archived Units</p>
        </StyledToggle>
        <TableContainer>
          {unitsLoading ? (
            <p>Loading Units...</p>
          ) : (
            <Table>
              <thead>
                <tr>
                  <SortableTh
                    label="Unit"
                    sortField="code"
                    handleUpdateSort={this.handleUpdateSort}
                    currentSortField={sortField}
                    sortDirection={sortDirection}
                  />
                  <SortableTh
                    label="Title"
                    sortField="title"
                    handleUpdateSort={this.handleUpdateSort}
                    currentSortField={sortField}
                    sortDirection={sortDirection}
                  />
                  <SortableTh
                    label="Date Last Modified"
                    sortField="updatedAt"
                    handleUpdateSort={this.handleUpdateSort}
                    currentSortField={sortField}
                    sortDirection={sortDirection}
                  />
                  <th>Edit the Unit</th>
                </tr>
              </thead>
              <tbody>
                {units.map(unit => (
                  <tr key={unit._id}>
                    <td>{unit.code}</td>
                    <td>{unit.title}</td>
                    <td>
                      {unit.updatedAt
                        ? moment(unit.updatedAt).format('llll')
                        : 'N/A'}
                    </td>
                    <td>
                      {showArchived ? (
                        <Button
                          primary
                          onClick={() => this.handleRestoreUnit(unit._id)}>
                          Restore
                        </Button>
                      ) : (
                        <div>
                          <Link to={`/units/${unit._id}/`}>
                            <Button primary>Edit</Button>
                          </Link>
                          <Link to={`/units/duplicate/${unit._id}`}>
                            <Button>Duplicate</Button>
                          </Link>
                          <Button
                            accent
                            onClick={() => this.handleArchiveUnit(unit._id)}>
                            Archive
                          </Button>
                        </div>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
        </TableContainer>
        <ActionsContainer>
          <PaginationContainer>
            <p>Items per page:</p>
            <PaginationButton id="set-cursor" width="30px">
              {pageSize}
            </PaginationButton>
            <Menu
              target="set-cursor"
              valign="top"
              onClick={this.handleChangePageSize}>
              <MenuItem value={10}>10</MenuItem>
              <MenuItem value={25}>25</MenuItem>
              <MenuItem value={50}>50</MenuItem>
              <MenuItem value={100}>100</MenuItem>
              <MenuItem value={200}>200</MenuItem>
            </Menu>
            <p>
              Page {page + 1} of {totalPages}
            </p>
            <PaginationButton
              disabled={page < 1}
              width="70px"
              onClick={this.handlePreviousPage}>
              Previous
            </PaginationButton>
            <PaginationButton
              disabled={page + 1 >= totalPages}
              width="70px"
              onClick={this.handleNextPage}>
              Next
            </PaginationButton>
          </PaginationContainer>
          <Link to="/units/create/">
            <Button raised primary>
              Create New Unit
            </Button>
          </Link>
        </ActionsContainer>
      </div>
    )
  }
}

export default withRouter(UnitsScreen)



// WEBPACK FOOTER //
// ./src/Units/UnitsScreen/index.js